<template>
  <div class="stepOneMain">
    <div class="scroll_wrap">
      <vue-scroll ref="scroll">
        <el-form
          ref="plainInfo"
          :model="plainInfo"
          :rules="formRules"
          label-width="180px"
          class="black_form"
        >
          <el-form-item label="主教练"
            ><div style="font-size: 16px">
              {{ chiefCoachName }}
            </div></el-form-item
          >
          <el-form-item label="训练开始时间" prop="plainStartTime">
            <el-date-picker
              v-model="plainInfo.plainStartTime"
              type="datetime"
              placeholder="请选择训练开始时间"
              value-format="timestamp"
              :editable="false"
              :picker-options="StartPickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <div>
            <div :span="8">
              <el-form-item label="训练量">
                <el-select
                  v-model="plainInfo.trainingVolume"
                  placeholder="请选择训练量"
                >
                  <el-option
                    v-for="(item, index) in trainingVolumeList"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div :span="8">
              <el-form-item label="训练强度">
                <el-select
                  v-model="plainInfo.TrainingIntensity"
                  placeholder="请选择训练强度"
                >
                  <el-option
                    v-for="(item, index) in TrainingIntensityList"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="训练地点" prop="trainingPlace">
            <el-input
              v-model="plainInfo.trainingPlace"
              style="width: 445px"
              placeholder="请输入训练地点"
            ></el-input>
          </el-form-item>
          <el-form-item label="训练计划选择教案" prop="fileStatus">
            <el-radio-group v-model="plainInfo.fileStatus">
              <el-radio :label=0>系统中编写的教案</el-radio>
              <el-radio :label=1>图片教案文件上传</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="line"></div>
          <!-- ================================= -->
          <div v-show="!plainInfo.fileStatus">
            <el-form-item
              label="系统中编写的教案"
              :rules="[{ required: true, message: '请选择教案' }]"
            >
              <el-button type="primary" @click="chooseTutorial = true"
                >选择教案</el-button
              >
            </el-form-item>
            <el-form-item label="训练主题" prop="title">
              <el-input
                v-model="plainInfo.title"
                style="width: 445px"
                placeholder="请选择训练主题"
              ></el-input>
            </el-form-item>
            <el-form-item label="训练总体描述">
              <quill-editor v-model="plainInfo.overallDescription" class="simple_editor" :options="editorOption"></quill-editor>
            </el-form-item>
            <div v-if="plainInfo.linkList.length">
              <div class="line"></div>
              <div
                v-for="(item, index) in plainInfo.linkList"
                :key="index"
                class="link_item"
              >
                <div class="link_title">
                  <img src="@/assets/images/common/edit_2.png" alt="" />
                  {{ $t("train") }}{{ index + 1 }}
                </div>
                <div class="info_wrap">
                  <div class="info">
                    <el-form-item
                      :label="$t('trainingTopic')"
                      :prop="'linkList.' + index + '.drillTitle'"
                      :rules="[
                        {
                          required: true,
                          message: $t('trainingTopicPlaceholder'),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input
                        v-model="item.drillTitle"
                        style="width: 200px"
                        :placeholder="$t('trainingTopicPlaceholder')"
                      ></el-input>
                    </el-form-item>
                    <el-form-item
                      :label="$t('classification')"
                      :prop="'linkList.' + index + '.drillCategoryId'"
                      :rules="[
                        {
                          required: true,
                          message: $t('classificationPlaceholder'),
                          trigger: 'change',
                        },
                      ]"
                    >
                      <el-select
                        v-model="item.drillCategoryId"
                        style="width: 200px"
                      >
                        <el-option
                          v-for="(item, index) in tutorialType"
                          :key="index"
                          :label="item.nameZh"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="img_wrap">
                    <img :src="item.coverImgUrl" @error="imgErr" />
                    <div class="detail" @click="linkDetail(index)">
                      {{ $t("look") }}
                    </div>
                  </div>
                </div>
                <el-form-item :label="$t('trainingDuration')">
                  <div class="slider">
                    <el-slider
                      v-model="item.timeSpent"
                      :step="5"
                      :min="0"
                      :max="120"
                      :marks="marks"
                      :show-tooltip="false"
                      @change="changeTime"
                    ></el-slider>
                    <p class="time">{{ item.timeSpent }}</p>
                  </div>
                </el-form-item>
                <div class="line"></div>
              </div>
              <el-form-item :label="$t('totalTimes')" prop="allTime">
                <el-input
                  v-model="plainInfo.allTime"
                  disabled
                  style="width: 80px"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div v-show="plainInfo.fileStatus">
            <el-form-item
              label="图片教案文件上传"
              class="plan-upload"
              :class="{ 'hide-upload': uploadFileList.length > 3 }"
              :error="uploadErroeMsg"
              :rules="{required: true}"
            >
              <el-upload
                :action="uploadPath"
                :on-remove="handleRemoveFile"
                :before-upload="beforeUpload"
                :on-exceed="handleExceed"
                :on-success="handleSuccessUpload"
                :file-list="uploadFileList"
                :multiple="false"
                list-type="picture-card"
                :limit="4"
              >
                <!-- <el-button size="small" type="primary">点击上传</el-button> -->
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png/jpeg/gif文件，且不超过20M，最多上传4个文件。
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="训练时长合计" prop="allTime">
              <el-input
                v-model="plainInfo.allTime"
                style="width: 80px; margin-right: 10px"
              ></el-input
              >分钟
            </el-form-item>

            <el-form-item label="训练主题" prop="title">
              <el-input v-model="plainInfo.title" style="width: 445px" placeholder="请选择训练主题"></el-input>
            </el-form-item>

            <el-form-item label="训练总体描述">
              <quill-editor v-model="plainInfo.overallDescription1" class="simple_editor" :options="editorOption"></quill-editor>
            </el-form-item>
          </div>

          <!-- ================================= -->
        </el-form>
      </vue-scroll>
    </div>
    <!-- 选择教案 -->
    <el-dialog
      :visible.sync="chooseTutorial"
      width="820px"
      :close-on-click-modal="false"
      custom-class="yioks_alert3"
    >
      <div class="tutorial_wrap">
        <div class="search_wrap">
          <el-select
            v-model="categoryId"
            style="width: 180px; margin-right: 10px"
            @change="getTutorial"
          >
            <el-option :label="$t('classifications')" value=""></el-option>
            <el-option
              v-for="(item, index) in tutorialType"
              :key="index"
              :label="item.nameZh"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="skillLevelId"
            style="width: 180px; margin-right: 10px"
            @change="getTutorial"
          >
            <el-option :label="$t('teams')" value=""></el-option>
            <el-option
              v-for="(item, index) in squadSortName"
              :key="index"
              :label="item.nameZh"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-input
            v-model="title"
            style="width: 220px"
            :placeholder="$t('planSearchTips')"
            @keyup.enter.native="getTutorial"
          ></el-input>
          <el-button
            icon="el-icon-search"
            type="primary"
            style="margin-left: 20px"
            @click="getTutorial"
            >{{ $t("search") }}</el-button
          >
        </div>
        <div class="tutorial">
          <vue-scroll v-show="dataReady" :ops="ops">
            <div
              v-for="(item, index) in tutorialList"
              :key="index"
              class="item"
            >
              <div class="title">{{ item.title }}</div>
              <div class="info_content">
                <img :src="item.coverImgUrl" alt="" @error="imgErr" />
                <div class="info">
                  <p>{{ $t("author") }}：{{ item.authorName }}</p>
                  <p>{{ $t("classification") }}：{{ item.categoryZh }}</p>
                  <p>
                    {{ $t("language") }}：{{
                      item.language === "zh" ? $t("Chinese") : $t("English")
                    }}
                  </p>
                  <p>{{ $t("team1") }}：{{ item.skillLevelZh }}</p>
                </div>
                <div class="btn_wrap">
                  <p>{{ $t("lastUpdateTime") }}：{{ item.updatedAt | time }}</p>
                  <div class="btn" @click="getDetail(item.uuid)">
                    {{ $t("confirmPlan") }}
                  </div>
                </div>
              </div>
            </div>
          </vue-scroll>
          <yioks-loading v-if="loading"></yioks-loading>
          <yioks-empty v-if="empty" :whiteBg="true"></yioks-empty>
        </div>
        <Pagination class="wihte_pagination" :total="total" :page.sync="page" />
      </div>
    </el-dialog>
    <!-- 查看教案详情 -->
    <el-dialog
      :visible.sync="showDetail"
      width="700px"
      :close-on-click-modal="false"
      custom-class="yioks_alert3"
    >
      <div v-if="plainInfo.linkList.length" class="detail_wrap">
        <vue-scroll :ops="ops">
          <div class="title">
            {{ $t("linkTitle") }}: {{ plainInfo.linkList[idx].drillTitle }}
          </div>
          <div class="detail">
            <div class="tutorial_wrap">
              <div class="tutorial" style="width: 350px; height: 200px">
                <!--<template v-if="flashFlag">-->
                <!--<object-->
                <!--:key="plainInfo.linkList[idx].id"-->
                <!--type="application/x-shockwave-flash"-->
                <!--name="sspviewer"-->
                <!--align="middle"-->
                <!--:data="`${HOSTURL}/uploads/flash-tool/yioks-football-view.swf?revision=1463`"-->
                <!--width="337"-->
                <!--height="207">-->
                <!--<param name="quality" value="high">-->
                <!--<param name="bgcolor" value="#000000">-->
                <!--<param name="play" value="false">-->
                <!--<param name="loop" value="false">-->
                <!--<param name="wmode" value="transparent">-->
                <!--<param name="scale" value="showall">-->
                <!--<param name="menu" value="true">-->
                <!--<param name="devicefont" value="false">-->
                <!--<param name="salign" value="">-->
                <!--<param name="allowscriptaccess" value="sameDomain">-->
                <!--<param name="allowfullscreen" value="true">-->
                <!--<param name="flashvars" :value="`xmlRequestFile=${xmlUrl}${tutorial.uuid ? tutorial.uuid +'&' : trainUuid + '?'}screenSortOrder=${idx}`">-->
                <!--</object>-->
                <!--</template>-->
                <img
                  :src="plainInfo.linkList[idx].coverImgUrl"
                  class="tutorial_img"
                />
                <!--<yioks-sspviewer  :screenId="idx" :requestXmlUrl="`${xmlUrl}${tutorial.uuid ? tutorial.uuid : trainUuid }`" />-->
              </div>
              <!--<img v-if="flashFlag" :src="plainInfo.linkList[idx].coverImgUrl" class="tutorial_img">-->
              <!--<template v-if="!flashFlag">-->
              <!--<flash-tips :min="true"></flash-tips>-->
              <!--</template>-->
            </div>
            <div class="info">
              <p>{{ $t("trainingTopic") }}: {{ plainInfo.title }}</p>
              <p>
                {{ $t("linkTitle") }}: {{ plainInfo.linkList[idx].drillTitle }}
              </p>
              <p>{{ $t("author") }}: {{ tutorial.authorName }}</p>
            </div>
          </div>
          <p class="description">{{ $t("linkDescription") }}</p>
          <div
            style="margin-right: 20px"
            v-html="plainInfo.linkList[idx].drillComment"
          ></div>
        </vue-scroll>
      </div>
    </el-dialog>
    <div class="next_btn_wrap">
      <el-button
        type="primary"
        style="margin-right: 0.2rem"
        @click="saveData('temporarily')"
        :loading="saveBtn"
        >编写完成并保存</el-button
      >
      <el-button
        type="primary"
        style="margin-right: 0.2rem"
        :loading="saveBtn"
        @click="saveData('next')"
        >下一步</el-button
      >
      <el-button type="danger" @click="showTip = true">取消</el-button>
    </div>
    <yioks-tip-loading
      :showTip="showTip"
      :tipMsg="$t('waivedSubmission')"
      @callback="goBack"
    ></yioks-tip-loading>
    <yioks-tip-loading
      :showTip="temporarily"
      :tipMsg="tips"
      @callback="saveTemporarily"
      :confirmLoding="false"
    ></yioks-tip-loading>
    <yioks-tip-loading
      :showTip="confirmSubmit"
      :tipMsg="confirmTips"
      @callback="confirmSave"
      :confirmLoding="false"
    ></yioks-tip-loading>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; // 富文本编辑器，下面的样式必须引入
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import tutorial from "@/api/tutorial";
import common from "@/api/common";
import placeHolderImg from "@/assets/images/common/plan_default.png"; // 教案的默认图片
import { flashCheck, filterCode } from "@/utils/yioks_filter";
import training from "@/api/training";
import storage from "@/utils/storage";
export default {
  components: {
    quillEditor,
    'Pagination': () => import("@/components/Pagination"),
    "yioks-sspviewer": () => import("@/components/sspViewer/sppCanvas"),
    'FlashTips': () => import("@/components/FlashTips"),
  },
  data() {
    return {
      // 表单信息
      tips: "确定暂时保存并返回吗?",
      confirmSubmit: false,
      confirmTips: "确定保存并进入下一步吗?",
      plainInfo: {
        fileStatus:0,
        plainStartTime: "", // 训练开始时间
        trainingVolume: "", // 训练量
        TrainingIntensity: "", // 训练强度
        title: "", // 训练主题
        overallDescription: "", // 训练总体描述--教案
        overallDescription1: "", // 训练总体描述--文件
        linkList: [], // 选中教案的教案环节
        allTime: 0, // 训练总时长
        trainingPlace: "", // 训练地点
        eventImgUrl: "", //图片文件路径
        trainingPlanFileList: [], // 文件列表

      },
      // 表单验证规则
      formRules: {
        plainStartTime: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
        title: [{ required: true, message: "请输入训练主题", trigger: "blur" }],
        allTime: [
          { required: true, message: "请输入训练时长", trigger: "blur" },
        ],
        trainingPlace: [
          { required: true, message: "请输入训练地点", trigger: "blur" },
        ],
        // eventImgUrl: [
        //   { required: true, message: "请上传训练教案图片", trigger: "blur" },
        // ],
      },
      // 训练量
      trainingVolumeList: ["高", "中", "低"],
      // 训练难度
      TrainingIntensityList: [
        "100%",
        "90%",
        "80%",
        "70%",
        "60%",
        "50%",
        "40%",
        "30%",
        "20%",
        "10%",
        "0%",
      ],
      // vue-edit 设置，只需要三个
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"], // 加粗 斜体 下划线 删除线
          ],
        },
        placeholder: this.$t("defaultPlaceholder"),
      },
      userRole: storage.get("userInfo").userRole, // 登录角色
      chooseTutorial: false, // 选择教案的 dialog
      categoryId: "", // 分类的 id
      skillLevelId: "", // 球队的 id
      title: "", // 教案的 title
      tutorialType: [], // 教案类型数据
      squadSortName: [], // 球队姓名
      loading: true,
      dataReady: false,
      empty: false,
      tutorialList: [], // 教案列表
      page: 0,
      total: 0,
      ops: {
        // 在白色背景下 vue-scroll 样式
        rail: {
          background: "#000",
          opacity: 0.2,
        },
        bar: {
          background: "#000",
          opacity: 0.3,
        },
      },
      marks: {
        // silder ,拖动滑块组件的标记
        0: "0",
        20: "20",
        40: "40",
        60: "60",
        80: "80",
        100: "100",
        120: "120",
      },
      showDetail: false, // 查看教案详情 dialog
      flashFlag: false, // 浏览器是否允许 flash
      idx: 0, // 第几个环节
      chiefCoachName: "", // 教练姓名
      chiefCoachUuid: "", // 教练uuid
      tutorial: {}, // 教案详细信息
      showTip: false, // 取消提示
      squadUuid: this.$route.query.squadUuid,
      aheadTrainingStartTime: this.$route.query.aheadTrainingStartTime,
      aheadTrainingEndTime: this.$route.query.aheadTrainingEndTime,
      aheadTrainingUuid: this.$route.query.aheadTrainingUuid,
      squadInfo: {}, // 球队的详情
      temporarily: false, // 暂时保存提示
      data: "", // 需要保存的数据
      trainUuid: this.$route.query.uuid,
      xmlUrl: "/api/editor/myXmlView?sessionUuid=", // 原教案详情的 xml 接口 /api/editor/myXmlView?sessionUuid=xxx&screenSortOrder=x
      HOSTURL: process.env.VUE_APP_URL,
      saveBtn: false, // 下一步按钮 loading
      trainingStatus: this.$route.query.trainingStatus,
      uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], //文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件
      fileListChangedFlag: false, //文件列表是否更改
      type: "",
    };
  },

  computed: {
    // planeType() {
    //   const { planeType } = this.$route.query; // byDoc 文件创建计划；byTrain 教案创建计划
    //   return planeType || "byTrain";
    // },

    // 时间选择器
    StartPickerOptions() {
      const aheadTrainingStartTime = this.aheadTrainingStartTime;
      const aheadTrainingEndTime = this.aheadTrainingEndTime;
      return {
        disabledDate(time) {
          return time.getTime() < aheadTrainingStartTime || time.getTime() > aheadTrainingEndTime;
        },
      };
    },

  },

  watch: {
    // 教案列表中搜索 title 为空时，自动从新请求数据
    title(val) {
      if (!val) this.getTutorial();
    },
    page() {
      this.getTutorial();
    },
  },
  created() {
    this.flashFlag = flashCheck();
    this.getCommon();
    this.getTutorial();
    if (this.trainUuid) this.getPlainInfo();
  },
  methods: {
    // changeType(val){
    //   if(val === "Train"){
    //
    //   }
    //   if(val === "Doc"){
    //
    //   }
    // },
    // 图片错误处理
    imgErr(event) {
      event.srcElement.src = placeHolderImg; // 教案图片找不到显示的图片
    },
    // 教案列表 - 获取球队和教案类型
    getCommon() {
      tutorial.getCategory().then((res) => {
        this.tutorialType = res;
      });
      tutorial.getCoachSkill().then((res) => {
        this.squadSortName = res;
      });
      if (this.squadUuid) {
        common.getSquadInfo(this.squadUuid).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            this.squadInfo = res.squad;
            this.chiefCoachName = res.squad.chiefCoachName;
            this.chiefCoachUuid = res.squad.chiefCoachUuid;
          }
        });
      }
    },
    // 获取教案 --- 此处一近页面就请求，不影响页面加载，增加用户体验
    getTutorial() {
      this.loading = true;
      this.empty = true;
      this.dataReady = false;
      let request = tutorial.getMyTutorial;
      if (this.userRole === "organ") {
        request = tutorial.getOrganTutorial;
      } else if (this.userRole === "system" || this.userRole === "admin") {
        request = tutorial.getOfficialTutorial;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = tutorial.getYouthTutorial;
      }
      request({
        page: this.page,
        title: this.title,
        categoryId: this.categoryId,
        skillLevelId: this.skillLevelId,
      })
        .then((res) => {
          this.loading = false;
          if (res.totalElements) {
            this.dataReady = true;
            this.tutorialList = res.content;
            this.total = res.totalElements;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    // 当存在 trainUuid 即 url 存在 uuid 时，代表编辑，请求回显数据
    getPlainInfo() {
      training.trainInfo(this.trainUuid).then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          this.$router.push("/home/index");
        } else {
          this.type = "edit"
          this.plainInfo.linkList = res.drillList.map((item) => {
            return {
              ...item,
              drillTitle: item.trainingTitle,
              timeSpent: Number(item.timeSpent),
            };
          });
          this.chiefCoachName = res.plan.chiefCoachName;
          this.chiefCoachUuid = res.plan.chiefCoachUuid;
          this.squadUuid = res.plan.squadUuid;
          this.plainInfo.plainStartTime = res.plan.trainingTime;
          this.plainInfo.trainingVolume = res.plan.trainingAmount;
          this.plainInfo.TrainingIntensity = res.plan.trainingIntensity;
          this.plainInfo.title = res.plan.trainingName;
          // 训练总体描述，名字冲突，导致光标丢失，所以进行判断赋值
          if (res.plan.fileStatus === 1){
            this.plainInfo.overallDescription1 = res.plan.overallEvalComment;
          }else {
            this.plainInfo.overallDescription = res.plan.overallEvalComment;
          }
          this.plainInfo.allTime = res.plan.trainingTotalTime;
          this.plainInfo.trainingPlace = res.plan.trainingPlace;

          this.plainInfo.eventImgUrl = res.plan.eventImgUrl;
          this.plainInfo.fileStatus = res.plan.fileStatus;

          this.tutorial.authorName = res.plan.authorUserName;
          this.plainInfo.organShortName = this.squadInfo.organShortName;
          this.plainInfo.organUuid = this.squadInfo.organUuid;
          this.plainInfo.youthUuid = this.squadInfo.youthUuid;
          this.plainInfo.youthShortName = this.squadInfo.youthShortName;
          this.chiefCoachUuid = this.squadInfo.chiefCoachUuid;

          this.aheadTrainingUuid = res.plan.aheadTrainingUuid;
          // this.chiefCoachName = this.squadInfo.chiefCoachName
          // 回显时，查看教案详情，请求 复制教案的 XML /api/zuxie/guozi/event/trainXmlView/XXX?screenSortOrder=x
          // 复制教案的原因  防止原教案改变，此处也相应改变
          this.xmlUrl = "/api/zuxie/guozi/event/trainXmlView/";

          //单个图片，暂时隐藏
          // if (res.plan.eventImgUrl){
          //   this.uploadFileList = [
          //     {
          //       name: '',
          //       url: res.plan.eventImgUrl
          //     }
          //   ]
          // }else {
          //   this.uploadFileList = []
          // }

          if (res.trainingPlanFileList && res.trainingPlanFileList.length) {
            this.uploadFileList = [];
            this.uploadFileList = res.trainingPlanFileList.map((item) => {
              const { fileName, fileUrl, uuid } = item;
              return {
                name: fileName,
                url: fileUrl,
                id: uuid,
                meta: item,
              };
            });
          }
        }
      });
    },
    // 获取教案详细信息
    getDetail(uuid) {
      this.plainInfo.allTime = 0;
      this.chooseTutorial = false;
      tutorial
        .getTutorialDetail({ sessionUuid: uuid })
        .then((res) => {
          this.plainInfo.overallDescription = res.overallDescription;
          this.plainInfo.title = res.title;
          this.tutorial = res;
          // timeSpent 必须为 Number
          this.plainInfo.linkList = res.planTacticalDrills.map((item) => {
            this.plainInfo.allTime += Number(item.timeSpent);
            return {
              ...item,
              timeSpent: Number(item.timeSpent),
            };
          });
          // 重置 XML 请求
          this.xmlUrl = "/api/editor/myXmlView?sessionUuid=";
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    // 调整环节的时间，总时间相应改变
    changeTime() {
      this.plainInfo.allTime = 0;
      this.plainInfo.linkList.forEach((item) => {
        this.plainInfo.allTime += item.timeSpent;
      });
    },
    // 查看第几个环节详情
    linkDetail(index) {
      this.idx = index;
      this.showDetail = true;
    },
    // 球队信息
    // 返回
    goBack(isShow) {
      if (isShow) {
        if (this.trainingStatus === "INCOMPLETE") {
          this.$router.replace({
            path: "/training/list",
            query: {
              // idx: 1,// 因为胡总要求，只有一个页面，故此先不传
            },
          });
        } else {
          this.$router.go(-1);
        }
      }
      this.showTip = false;
    },
    // 下一步，保存数据
    saveData(val) {
      // 关于传过来的教练姓名没法限制，，，，所以存在bug!!! 用户可以删除 url 的 name 且能通过~~~
      this.$refs["plainInfo"].validate((valid) => {
        if (valid) {
          // 暂时保存 或者使用文件创建训练计划 可以不传教案
          if (val !== "temporarily" && !this.plainInfo.fileStatus) {

            // 必须选择教案
            if (!this.plainInfo.linkList.length) {
              this.$message.error("请选择教案");
              return;
            }
          }
          // 不是暂时保存 并且 是图片上传教案 必须图片
          if (val !== "temporarily" && this.plainInfo.fileStatus) {

            // 必须选择穿图片
            if (!this.uploadFileList_edit.length && !this.uploadFileList.length) {
              this.uploadErroeMsg = "请上传图片教案";
              this.$message.error("请上传图片教案");
              return;
            }
          }
          let data = {};
          if (this.plainInfo.fileStatus) { // 文件上传

            //  编辑模式下修改上传的文件列表 （仅上传新增的文件）
            if (this.type === "edit") {
              if (this.uploadFileList_edit.length) {
                this.$set(this.plainInfo, "trainingPlanFileList", this.uploadFileList_edit);
              } else {
                // 用户没有新增加文件 - 清空提交文件列表
                this.$set(this.plainInfo, "trainingPlanFileList", []);
              }
            }

            data = {
              planForm: {
                organShortName: this.squadInfo.organShortName,
                organUuid: this.squadInfo.organUuid,
                youthUuid: this.squadInfo.youthUuid,
                youthShortName: this.squadInfo.youthShortName,
                authorUserName: this.tutorial.authorName,
                authorUserUuid: this.tutorial.authorUserUuid,
                squadUuid: this.squadUuid,
                categoryId: this.tutorial.categoryId,
                chiefCoachName: this.chiefCoachName,
                chiefCoachUuid: this.chiefCoachUuid,
                editorTacticalUuid: this.tutorial.uuid,
                localLessonPlanUrl: "",
                overallEvalComment: this.plainInfo.overallDescription1,
                trainingAmount: this.plainInfo.trainingVolume,
                trainingIntensity: this.plainInfo.TrainingIntensity,
                trainingName: this.plainInfo.title,
                trainingPlace: this.plainInfo.trainingPlace,
                trainingTime: this.plainInfo.plainStartTime,
                trainingTotalTime: this.plainInfo.allTime,
                xmlContent: this.tutorial.teachingXml,
                uuid: this.trainUuid,
                eventImgUrl: this.plainInfo.eventImgUrl, //图片文件路径
                fileStatus: this.plainInfo.fileStatus,
                aheadTrainingUuid: this.aheadTrainingUuid,
              },
              trainingPlanFileList: this.plainInfo.trainingPlanFileList,
            }
          } else { // 教案上传
            let linkList = [...this.plainInfo.linkList];
            data = {
              drillForm: linkList.map((item) => {
                return {
                  coverImgUrl: item.coverImgUrl,
                  drillCategoryId: item.drillCategoryId,
                  drillCategoryZh: this.filtertutorialType(
                    item.drillCategoryId
                  ),
                  drillComment: item.drillComment,
                  drillXmlComments: item.xmlContent,
                  editorTacticalDrillUuid: item.uuid,
                  skillsPhysical: item._skillsPhysical,
                  skillsPsychological: item._skillsPsychological,
                  skillsTactical: item._skillsTactical,
                  skillsTechnical: item._skillsTechnical,
                  timeSpent: item.timeSpent,
                  trainingTitle: item.drillTitle,
                  sortOrder: item.sortOrder,
                };
              }),
              planForm: {
                organShortName: this.squadInfo.organShortName,
                organUuid: this.squadInfo.organUuid,
                youthUuid: this.squadInfo.youthUuid,
                youthShortName: this.squadInfo.youthShortName,
                authorUserName: this.tutorial.authorName,
                authorUserUuid: this.tutorial.authorUserUuid,
                squadUuid: this.squadUuid,
                categoryId: this.tutorial.categoryId,
                chiefCoachName: this.chiefCoachName,
                chiefCoachUuid: this.chiefCoachUuid,
                editorTacticalUuid: this.tutorial.uuid,
                localLessonPlanUrl: "",
                overallEvalComment: this.plainInfo.overallDescription,
                trainingAmount: this.plainInfo.trainingVolume,
                trainingIntensity: this.plainInfo.TrainingIntensity,
                trainingName: this.plainInfo.title,
                trainingPlace: this.plainInfo.trainingPlace,
                trainingTime: this.plainInfo.plainStartTime,
                trainingTotalTime: this.plainInfo.allTime,
                xmlContent: this.tutorial.teachingXml,
                uuid: this.trainUuid,
                fileStatus: this.plainInfo.fileStatus,
                aheadTrainingUuid: this.aheadTrainingUuid,
              },
            };
          }
          this.data = data;
          if (val === "temporarily") {
            this.temporarily = true;
          } else {
            this.saveBtn = true;
            this.confirmSubmit = true;
          }
        } else {
          if (!this.plainInfo.trainingPlace || !this.plainInfo.plainStartTime) {
            this.$refs["scroll"].scrollTo({ y: 0 });
          } else {
            this.$refs["scroll"].scrollTo({ y: 200 });
          }
        }
      });
    },
    // 暂时保存并返回列表
    saveTemporarily(isSure) {
      if (isSure) {
        const requestName = this.plainInfo.fileStatus ? training.FirstTrainForDoc : training.FirstTrain
        requestName(this.data).then((res) => {
          if (this.trainingStatus === "INCOMPLETE") {
          } else {
            this.$router.go(-1);
          }
        });
      } else {
        this.temporarily = false;
      }
    },
    confirmSave(isSure) {
      if (isSure) {
        const requestName = this.plainInfo.fileStatus ? training.FirstTrainForDoc : training.FirstTrain
        requestName(this.data)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              this.saveBtn = false;
              this.confirmSubmit = false;
            } else {
              this.saveBtn = false;
              this.confirmSubmit = false;
              this.$emit("changeNav", {
                jump: 1,
                uuid: res.uuid,
                trainingStatus: res.trainingStatus,
                squadUuid: this.squadUuid,
                aheadTrainingStartTime: this.aheadTrainingStartTime,
                aheadTrainingEndTime: this.aheadTrainingEndTime,
                aheadTrainingUuid: this.aheadTrainingUuid,
              });
            }
          })
          .catch((err) => {
            this.confirmSubmit = false;
            this.saveBtn = false;
          });
      } else {
        this.confirmSubmit = false;
        this.saveBtn = false;
      }
    },
    // 获取分类的中文
    filtertutorialType(id) {
      let nameZh = "";
      this.tutorialType.forEach((item) => {
        if (item.id === id) nameZh = item.nameZh;
      });
      return nameZh;
    },

    // 删除文件
    handleRemoveFile(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        training.deleteTrainFile(uuid)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
          })
          .catch((err) => {
            console.error("err", err);
          });
        this.uploadFileList = this.uploadFileList.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileList = this.uploadFileList.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }

      this.$set(this.plainInfo, "trainingPlanFileList", this.uploadFileList);
      if(this.type === "edit") {
        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
          const  status = file.url !== item.url;
          return status
        })
      }

      // this.$set(this.plainInfo, "eventImgUrl", "");
      // this.uploadFileList = [];
    },
    // 图片验证
    beforeUpload(file) {
      const fileReg = /^.*\.(jpg|jpeg|png|gif)$/i;
      const fileType = fileReg.test(file.name);
      const fileLimit = file.size / 1024 / 1024 < 20;
      if (!fileLimit) {
        this.$message.error("单个上传文件大小不能超过20M");
      }
      if (!fileType) {
        this.$message.error("仅允许上传jpg、jpeg、png、gif类型图片");
      }
      return fileLimit && fileType;
    },
    // 验证超过超过文件数量
    handleExceed(file, fileList) {
      this.$message.warning(
        "仅支持上传四张图片，如需更换文件请先删除老文件后再尝试上传！"
      );
    },
    // 文件上传成功
    handleSuccessUpload(res, file, fileList) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, suffix, url } = res;
      const fileObj = {
        name: fileName,
        md5: fileMd5,
        url: url,
        fileName: fileName,
        fileUrl: url,
        fileType: suffix
      };
      if (this.type === "edit") {
        this.uploadFileList_edit.push(fileObj);
      }
      this.uploadFileList.push(fileObj);
      this.$set(this.plainInfo, "trainingPlanFileList", this.uploadFileList);


      // this.uploadFileList = fileList;
      // const { url, fileMd5 } = res;
      // this.$set(this.plainInfo, "eventImgUrl", url);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.stepOneMain
  display flex
  justify-content space-between
  flex-direction column
  height 590px
  .scroll_wrap
    height 540px
    padding 20px 10px
    background-color $black_color
    overflow hidden
    .line
      border-bottom 1px solid #FFF
      margin 0.5rem 0.2rem
    .link_item
      margin-right 20px
      .line
        margin-right 0
      .link_title
        display flex
        align-items center
        font-size 20px
        margin-bottom 20px
        margin-left 20px
        img
          width 28px
          height 28px
          margin-right 20px
      .info_wrap
        display flex
        .img_wrap
          position relative
          margin-left 20px
          height 100px
          img
            width 170px
            height 100px
          .detail
            background #FFF
            width 80px
            height 30px
            border-radius 5px
            color #999
            font-size 16px
            line-height 30px
            text-align center
            position absolute
            left 50%
            top 50%
            transform translate(-50%, -50%)
            cursor pointer
      .slider
        width 445px
        position relative
        .time
          position absolute
          font-size 16px
          right -50px
          top -5px
  .tutorial_wrap
    height 590px
    display flex
    flex-direction column
    .search_wrap
      display flex
      border-bottom 1px solid #DDD
      padding 20px 0
      margin 0 20px 10px
    .tutorial
      flex 1
      overflow hidden
      color #999
      font-size 16px
      .item
        padding 10px 0
        border-bottom 1px solid #CCC
        margin 0 20px
        .title
          padding 10px 0 25px 0
          font-size 20px
          font-weight bold
          color #000
        .info_content
          display flex
          img
            width 207px
            height 121px
            margin-right 25px
          .info
            display flex
            flex-direction column
            justify-content center
            flex 1
            p
              margin-bottom 10px
          .btn_wrap
            margin-right 40px
            .btn
              background $green_color2
              color #FFF
              height 40px
              text-align center
              line-height 40px
              margin 20px auto 0
              cursor pointer
  .detail_wrap
    padding 20px
    padding-right 0
    height 560px
    overflow hidden
    .title
      font-size 22px
      padding-bottom 20px
      margin-right 20px
      border-bottom 1px solid #DDD
    .detail
      display flex
      margin-right 20px
      .tutorial_wrap
        width 340px
        height 203px
        position relative
        .tutorial, .tutorial_img
          position absolute
          left 0
          top 0
          z-index 2
        .tutorial_img
          z-index 1
          width 336px
          height 198px
          top 4px
      .info
        font-size 18px
        padding 20px 0 0 20px
        p
          margin-bottom 20px
    .description
      font-size 18px
      padding 25px 0
  .next_btn_wrap
    width 100%
    display flex
    justify-content center
.plan-upload
  /deep/.el-upload__tip
    color #fff !important
.hide-upload
  /deep/.el-upload--picture-card
    display none !important
    // visibility hidden !important
    transition all 0.5s
.el-radio
  color white
</style>
<!--<style lang="stylus" scoped>-->
<!--.el-slider__marks .el-slider__marks-text-->
<!--  color white !important-->
<!--</style>-->
